var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.path != '/')?_c('div',{attrs:{"id":"tito-overlay","role":"dialog","aria-label":"Tito Widget"}},[_c('transition',{attrs:{"css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }